// extracted by mini-css-extract-plugin
module.exports = {"container":"_91c71e2","withTitle":"_faa5b2e"};